import Marionette from "../../../shared/marionette-mustache";
import { PublisherLinkListView } from "../../../desktop/views/partials/publisher-link-list";
import { PublisherModel } from "../../../desktop/models/publisher";
import { backboneViewProperties } from "../../../decorators/backbone-properties";

@backboneViewProperties({
    childView: PublisherLinkListView,
    tagName: "div",
    className: "full-text-sources-list"
})
export class PublisherLinkListsView extends Marionette.CollectionView<PublisherModel, PublisherLinkListView> {
    constructor(options?: Marionette.CollectionViewOptions<PublisherModel>) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/partials/publisher-link-lists.ts